<template>
  <div
    :class="[
      $style.filter_button,
      delimiterLeft ? $style.delimiter_left : '',
      delimiterRight ? $style.delimiter_right : '',
      isActive && showRefreshButton ? $style.with_refresh_button : '',
      'toolbar_filter_button'
    ]"
  >
    <vgp-icon-button
      v-if="isActive && showRefreshButton"
      data-testid="gp_autotest_project_header_filter_refresh_button"
      :icon="{ name:'update', size: 20}"
      :colors="buttonColors"
      :active="isActive"
      :class="$style.filter_refresh"
      @onClick="onClickRefreshFilter"
    />
    <vgp-icon-button
      data-testid="gp_autotest_project_header_filter_button"
      :icon="{ name:'filter', size: 20 }"
      :label="filterButtonLabel"
      :colors="buttonColors"
      :active="isOpen || isActive"
      :class="[isOpen || isActive ? $style.active : '', 'header-filter-btn', 'js_filter_btn']"
      @onClick="onClickFilter"
    />
  </div>
</template>

<script>
import vgpIconButton from '$$uiKitComp/globalButton/withIcon/iconButton.vue';

const filterRoutes = ['progressReports', 'budgetReports', 'timeReports', 'listView'];

export default {
  components: { vgpIconButton },
  props: {
    delimiterLeft: { type: Boolean, required: false, default: true },
    delimiterRight: { type: Boolean, required: false, default: true },
    showRefreshButton: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      locales: __,
      buttonColors: {
        color: '#333333',
        labelColor: '#191919',
        activeColor: '#11519A',
        hoverBg: '#F2F2F2',
        activeBg: '#D0E0F2',
        activeHoverBg: '#A1C1E6',
      },
    };
  },
  computed: {
    currentFilter() {
      return this.$store.getters['filter/currentFilter'];
    },
    currentRoute() {
      return this.$store.getters['headerView/currentRoute'];
    },
    isOpen() {
      return this.$store.getters['filter/isOpen'];
    },
    isActive() {
      return this.$store.getters['filter/isActive'];
    },
    isCompactToolbar() {
      return this.$store.getters['headerView/isCompactToolbar'];
    },
    filterButtonLabel() {
      if (this.isCompactToolbar && !this.isActive) {
        return '';
      }

      return this.locales('common_filter');
    },
  },
  methods: {
    onClickFilter() {
      if (this.currentFilter) {
        setTimeout(() => {
          this.sendAnalyticEvent();
          this.$store.commit('filter/toggleFilter', true);
        }, 0);
      }
    },
    onClickRefreshFilter() {
      const routeMode = this.currentRoute.params.mode;

      userExtAnalytics.log('header_click_filter_refresh_button', {
        from: routeMode === 'list' ? 'my tasks' : routeMode,
      });
      this.$store.dispatch('headerView/refreshFilter');
    },
    sendAnalyticEvent() {
      if (this.currentRoute.path.includes('/reports/')) {
        userExtAnalytics.log('report_filter_open');
      }
    },
  },
};
</script>

<style module lang='less'>
.filter_button {
  display: flex;
  align-items: center;

  .active {
    border-radius: 4px;
  }

  &.with_refresh_button {
     .active {
        border-radius: 0 4px 4px 0;
      }
  }

  &.delimiter_left {
    &::before {
      content: '';
      position: relative;
      width: 1px;
      height: 14px;
      display: block;
      background: #E5E5E5;
      margin-right: 4px;
    }
  }

  &.delimiter_right {
    &:after {
      content: '';
      position: relative;
      width: 1px;
      height: 14px;
      display: block;
      background: #E5E5E5;
      margin-left: 4px;
    }
  }
}

.filter_refresh {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: 1px;
}
</style>
